<template>
  <div class="">

    <div class="col-12">
      <div class="row">


        <div class="col-12">
          <div class="row">

            <div class="col-lg-3 ">
              <h3>فیلتر اشتراک ها</h3>
            </div>

            <div class="col-lg-9 text-left">

              <router-link :to="{name:'SubscriptionCharges'}">
                <button class="btn btn-primary rounded-pill">اشتراک ها</button>
              </router-link>

            </div>

            <div class="col-lg-12 mt-3">

              <div class="row">
                <div class="col-lg-5">
                  <label for="">جست و جو</label>
                  <form class="col-12" @submit.prevent="submitSearch">
                    <div class="row">
                      <b-form-input
                          v-model="searchWord"
                          placeholder="جستجو از طریق نام، نام خانوادگی، شماره تلفن"
                          class="col-lg-10"
                      ></b-form-input>
                      <b-button
                          @click="submitSearch"
                          variant="primary"
                          class="mr-2">
                        جستجو
                      </b-button>
                    </div>
                  </form>
                </div>
                <div class="col-lg-3">

                  <subscription-filter @subscription="filterSubscriptionManager"/>

                </div>
                <div class="col-lg-2">
                  <label for="">بازه تاریخی</label>
                  <date-picker range clearable auto-submit
                               @change="filterDateManager"
                               v-model="dateFilter"
                               placeholder="بازه تاریخی را انتخاب کنید"
                               format="YYYY-MM-DD HH:mm:ss" display-format="jYYYY/jM/jD"/>

                </div>
                <div class="col-lg-2">

                  <label for="">اعتبار</label>
                  <select @change="filterSortManager" class="custom-select">
                    <option value="asc">کم به زیاد</option>
                    <option value="desc">زیاد به کم</option>
                  </select>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <table class="table my-3 table-hover table-striped table-bordered table-responsive-md table-responsive-sm">
      <thead>
      <tr>
        <th>کاربر</th>
        <th>اشتراک</th>
        <th>توضیحات</th>
        <th>اعتبار</th>
        <th>#</th>
      </tr>
      </thead>

      <tr v-for="subscription in subscriptionsCharges">
        <th>

          <router-link target="_blank" :to="{name:'UpdateUser',params:{id:subscription.user.id}}">
            {{ subscription.user.name }} {{ subscription.user.last_name }}
          </router-link>

        </th>

        <th>
          {{ subscription.subscription.name }} - {{ subscription.subscriptionItem.name }}
        </th>

        <th>{{ subscription.description }}</th>

        <th class="text-center">
          <span dir="ltr">{{ subscriptionChargeValueManager(subscription) }}

            <span class="badge " v-if="subscriptionRemaining(subscription)"
                  :class="{'badge-success':subscriptionRemaining(subscription) > 0 ,'badge-danger':subscriptionRemaining(subscription) < 0 }"> {{
                subscriptionRemaining(subscription)
              }} </span>

          </span>
        </th>

        <th>
          <div class="  my-2 col-lg-auto col-md-12 text-center col-sm-12">
            <b-icon-clock-history v-b-modal="`subscription-charge-history-${subscription.id}`"
                                  class="h5 mx-2 "/>

            <b-icon-pencil-square v-b-modal="`subscription-charge-${subscription.id}`" class="h5 mx-2 "/>
            <b-icon-trash @click="removeSubscription(subscription)" class="h5 mx-2 "/>
          </div>
        </th>

        <b-modal size="lg" :id="`subscription-charge-${subscription.id}`" hide-footer>
          <div class="text-right" dir="rtl">
            <charge-subscription @reloadItems="loadSubscriptionCharges" :subscription-charge="subscription"/>
          </div>
        </b-modal>


        <b-modal size="lg" :id="`subscription-charge-history-${subscription.id}`" hide-footer>
          <div class="text-right" dir="rtl">
            <subscription-charge-history :subscription-charge="subscription"/>
          </div>
        </b-modal>


      </tr>
    </table>

    <div class="row justify-content-center pt-3">
      <div class="mt-3 color">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>

  </div>
</template>

<script>
import Pagination from "../../components/dashboard/Pagination.vue";
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import SubscriptionChargeHistory from "../../components/dashboard/SubscriptionCharge/SubscriptionChargeHistory.vue";
import ChargeSubscription from "../../components/dashboard/SubscriptionCharge/ChargeSubscription.vue";
import CreateManualSubscriptionCharge
  from "../../components/dashboard/SubscriptionCharge/CreateManualSubscriptionCharge.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import SubscriptionFilter from "../../components/dashboard/Subscription/SubscriptionFilter.vue";

export default {
  name: "SubscriptionCharge",
  components: {
    SubscriptionFilter,
    datePicker: VuePersianDatetimePicker,
    CreateManualSubscriptionCharge,
    ChargeSubscription,
    SubscriptionChargeHistory,
    Pagination
  },
  data() {
    return {
      subscriptionsCharges: [],
      paginationMeta: [],
      searchWord: '',
      dateFilter: ''
    }
  },
  methods: {
    loadSubscriptionCharges(page = 1) {
      let req = this.$store.dispatch('SubscriptionCharge/subscriptionChargeFilterable', page)
      req.then(res => {
        let data = res.data.data
        this.subscriptionsCharges = data.data
        this.paginationMeta = data.meta
      })
    },
    changePage(page) {
      this.loadSubscriptionCharges(page)
    },
    subscriptionChargeValueManager(subscriptionCharge) {
      let value = subscriptionCharge.value
      if (subscriptionCharge.subscription.value_type == 'date') {
        return dateConverter(value, '/', true)
      }
      return value
    },
    submitSearch() {
      this.$store.commit('SubscriptionCharge/setFilters', {key: 'search', value: this.searchWord})
      this.loadSubscriptionCharges()
    },
    removeSubscription(item) {
      if (confirm('آیا از حذف اطمینان دارید؟')) {
        this.$store.dispatch('SubscriptionCharge/deleteSubscriptionCharges', item).then((res) => {
          toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
          this.loadSubscriptionCharges()
        })
      }
    },
    filterSortManager(event) {
      let value = event.target.value
      this.$store.commit("SubscriptionCharge/setFilters", {key: "sort", value: `value,${value}`});
      this.loadSubscriptionCharges()
    },
    filterDateManager() {
      this.$store.commit("SubscriptionCharge/setFilters", {key: "date_filter", value: this.dateFilter});
      this.loadSubscriptionCharges()
    },
    filterSubscriptionManager(subscription) {
      let value = subscription

      if (value != '') {
        value = value.id
      }

      this.$store.commit("SubscriptionCharge/setFilters", {
        key: "subscription_charge_subscription_filter",
        value: value
      });
      this.loadSubscriptionCharges()
    },
    subscriptionRemaining(subscriptionCharge) {
      let value = new Date(subscriptionCharge.value); // تبدیل مقدار به تاریخ
      let today = new Date(); // تاریخ امروز

      if (subscriptionCharge.subscription.value_type === 'date') {
        let diffTime = value - today; // اختلاف زمانی بر حسب میلی‌ثانیه
        let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // تبدیل به روز

        return diffDays
      }

      return false;
    }
  },
  mounted() {
    this.$store.commit("SubscriptionCharge/setFilters", {key: "sort", value: `value,asc`});
    this.loadSubscriptionCharges()
  }
}
</script>

<style scoped>
.table tr:nth-child(odd) {
  background: white;
}
</style>